import classNames from "classnames";
import { DComponent } from "../DComponent";
import AuthEmail from "./components/AuthEmail";
import { apiConfirmAuth, apiGetAuthProvider, apiRequestLogin, apiSendConfirmation } from "../../utils/api";
import { Auth } from "../../models/auth";
import { FireBase } from "../../utils/firebase";
import ConfirmOTP from "./components/ConfirmOTP";
import { DCStatic } from "../../models/DCStatic";
import UserInfo from "./components/UserInfo";
import { EVENTS, callEvent } from "../../utils/event";
import { LocalStorage } from "../../models/LocalStorage";
import { getParamUrl } from "../../utils/url";
import AuthPhoneNumber from "./components/AuthPhoneNumber";
import { ROOT_GLOBAL } from "../../global/root";
import OtherAuth from "./components/OtherAuth";
import AuthGoogle from "./components/AuthGoogle";
import AuthFacebook from "./components/AuthFacebook";
import AuthApple from "./components/AuthApple";
import { MINI_APP } from "../../utils/miniApp";
import { LIST_QUERYSTRING } from "../../utils/constant";
import { handleFeatureCallback } from "../../utils/feature";
import { setTranslateElement, setTranslateElements } from "../../utils/language";

const TYPE = {
  LOGIN: "login",
  KYC: "kyc",
}

const STEP_AUTH = {
  START_LOGIN: "login",
  OTP: "otp",
  USERINFO: "userInfo",
  LOGIN_DONE: "done",
}

export default class AuthSocial extends DComponent {
  constructor({
    parent,
    id,
    type = TYPE.LOGIN,
    provider,
    step,
    isMerchant,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AuthSocial", {

      }),
    });
    this.type = type;
    this.provider = provider;
    this.identity = "";
    this.accessToken = "";
    /** @type {AuthEmail | AuthPhoneNumber} */
    this.authSocial = undefined;
    /** @type {AuthEmail} */
    this._authEmail = undefined;
    /** @type {AuthPhoneNumber} */
    this._authPhone = undefined;
    /** @type {AuthGoogle} */
    this._authGoogle = undefined;
    /** @type {AuthFacebook} */
    this._authFaceBook = undefined;
    /** @type {AuthApple} */
    this._authApple = undefined;
    /** @type {ConfirmOTP} */
    this._authConfirm = undefined;
    /** @type {UserInfo} */
    this._userInfo = undefined;
    /** @type {OtherAuth} */
    this.otherAuth = undefined;
    this.step = step;
    this.isMerchant = isMerchant;
    this.translateTimeout = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AuthSocial");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.otherAuth = new OtherAuth({ parent: $(".other-auth", this.element), provider: this.provider, listAuth: LocalStorage.getAuthProviders(), onChangeAuth: (provider) => this.changeProvider(provider) });
    this.addEvent();
  }

  addEvent() {
    this.element.on('hide.bs.modal', () => {
      $("html, body").css("overflow", "auto");
      typeof this.onHideCallBack === "function" && this.onHideCallBack();
      this.resetAuth();
    })

    $(".close", this.element).on("click", () => {
      if (this.step === STEP_AUTH.LOGIN_DONE && typeof this.onCallBack === "function") {
        typeof this.onCallBack === "function" && this.onCallBack();
        this.hide();
      }
    });

    $(".loginDone .start-shopping", this.element).on("click", () => {
      if (this.type === TYPE.KYC || (typeof this.onCallBack === "function")) {
        typeof this.onCallBack === "function" && this.onCallBack();
        this.hide();
      } else {
        const cb = getParamUrl('cb');
        window.location.href = cb ? decodeURIComponent(cb) : ROOT_GLOBAL.AVAILABLE_STORES;
      }
    });
  }

  onSubmit(identity, credential) {
    this.identity = identity;
    this.authSocial.setLoading(true);

    const onError = (error) => {
      if (this.type === TYPE.KYC) {
        this.authSocial.setLoading(false);
        typeof this.authConfirm.confirmCodeError === "function" && this.authConfirm.confirmCodeError(error);
      } else {
        if (credential) {
          this.authSocial.setLoading(false);
          this.onError(error);
        } else {
          typeof this.authSocial.onError === "function" && this.authSocial.onError(error)
        }
      }
    }

    apiRequestLogin({
      provider: this.provider,
      identity: this.identity,
    },
      (data) => {
        if (data?.data?.access_token) {
          this.provider = data.data.provider;
          this.accessToken = data.data.access_token;

          this.authConfirm.updateAttributes({
            provider: this.provider,
            identity: this.identity,
            accessToken: this.accessToken,
          })

          apiSendConfirmation({
            provider: this.provider,
            identity: this.identity,
            access_token: this.accessToken,
          },
            (data) => {
              if (data?.data?.access_token) {
                this.accessToken = data.data.access_token;

                if (!credential) {
                  this.authConfirm.updateAttributes({
                    accessToken: this.accessToken,
                  })

                  this.authConfirm.setCodeConfirm(data?.raw_password);

                  switch (this.provider) {
                    case Auth.TYPE.FIREBASE_PHONE:
                      FireBase.setupPhone(this.identity, (confirmationResult) => {
                        this.authConfirm.showConfirmOTP(confirmationResult);
                      }, (error) => {
                        typeof onError === "function" && onError(error);
                      })
                      break;
                    default:
                      this.authConfirm.showConfirmOTP();
                      break;
                  }

                  this.setStep(STEP_AUTH.OTP);
                  typeof this.authSocial.onSuccess === "function" && this.authSocial.onSuccess(data.data)
                } else {
                  this.confirmAccessToken(credential)
                }
              } else {
                typeof onError === "function" && onError();
              }
            },
            (error) => {
              typeof onError === "function" && onError(error);
            }
          )
        } else {
          onError();
        }
      }, (error) => {
        onError(error);
      }
    )
  }

  confirmAccessToken(password) {
    let params = {
      "provider": this.provider,
      "identity": this.identity,
      "access_token": this.accessToken,
      "password": password
    }
    apiConfirmAuth(params, (data) => {
      const user = Auth.fromApiObject(data);
      if (user.authToken) {
        user.saveLoginInfo();
        this.onConfirmCodeSuccess(user);
      } else {
        this.onError();
      }
    }, (error) => {
      this.onError(error);
    });
  }

  /** @param {Auth} user */
  onConfirmCodeSuccess(user) {
    if (this.isMerchant) {
      this.setCallBack(() => {
        window.location.href = ROOT_GLOBAL.MERCHANT_MANAGEMENT;
      })
      this.showLoginDone(user);
      return;
    }
    if (user.fullName) {
      this.showLoginDone(user);
    } else {
      this.saveUserInfo(user.fullName, user.email);
      this.showAuthMoreInfo();
    }
  }

  // Login Done
  /** @param {Auth} user */
  showLoginDone(user) {
    this.handleCallBack({
      userName: user.fullName,
      email: user.email,
    });
  }

  saveUserInfo(userName, email, isForceSave = false) {
    if (isForceSave || !LocalStorage.getUserName()) {
      if (userName) {
        LocalStorage.setUserName(userName);
      }
    }
    if (isForceSave || !LocalStorage.getUserEmail()) {
      if (email) {
        LocalStorage.setUserEmail(email);
      }
    }
  }

  handleCallBack({ userName, email }) {
    this.saveUserInfo(userName, email, true);

    callEvent(EVENTS.CHANGE_AUTH_STATUS);

    this.setStep(STEP_AUTH.LOGIN_DONE);

    const cb = getParamUrl('cb');
    if (cb || this.onCallBack || this.type === TYPE.KYC) {
      setTranslateElement({
        element: $(".loginDone .start-shopping", this.element),
        i18nKey: "login_continue",
      })
    }
    if ((cb || this.onCallBack) && this.type !== TYPE.KYC) {
      this.translateTimeout = setTimeout(() => {
        if (typeof this.onCallBack === "function") {
          this.onCallBack(this.identity);
        } else {
          window.location.href = decodeURIComponent(cb);
        }
        this.hide();
      }, 3000);
    }
  }

  onSaveUserInfo(user) {
    this.showLoginDone(user);
    if (this.type === TYPE.KYC) {
      this.hide();
    }
  }

  changeProvider(provider, isDefault = false) {
    this.provider = provider;
    $(".identity-form", this.element).attr("provider", provider);
    provider !== LocalStorage.getLastAuthType() && LocalStorage.setLastAuthType(provider);
    this.resetError();

    switch (provider) {
      case Auth.TYPE.EMAIL:
        this.authSocial = this.authEmail;
        setTimeout(() => {
          this.authEmail.focus();
        }, isDefault ? 500 : 0);
        break;
      case Auth.TYPE.GOOGLE:
        this.authSocial = this.authGoogle;
        !isDefault && this.authGoogle.show();
        break;
      case Auth.TYPE.FACEBOOK:
        this.authSocial = this.authFaceBook;
        !isDefault && this.authFaceBook.show();
        break;
      case Auth.TYPE.APPLE:
        this.authSocial = this.authApple;
        !isDefault && this.authApple.show();
        break;
      default:
        this.authSocial = this.authPhone;
        setTimeout(() => {
          this.authPhone.focus();
        }, isDefault ? 500 : 0);
        break;
    }
  }

  onError(error) {
    $(".auth-message", this.element).text(error && error.message ? error.message : $.i18n("login_socialFail", this.provider));
    $(".auth-message", this.element).addClass("error");
  }

  resetError() {
    $(".auth-message", this.element).text("");
    $(".auth-message", this.element).removeClass("error");
  }

  show() {
    $("html, body").css("overflow", "hidden");
    this.element.removeClass("show-static");
    this.element.modal("show");
  }

  showStatic() {
    $("html, body").css("overflow", "hidden");
    this.element.addClass("show-static");
    this.element.modal({
      backdrop: 'static',
    });
  }

  showAuth() {
    if (LocalStorage.isMiniApp()) {
      MINI_APP.login();
      return;
    }

    this.setType(TYPE.LOGIN);
    this.setTitle();
    let defaultProvider = getParamUrl("provider") || LocalStorage.getLastAuthType();
    let provider = Object.values(Auth.TYPE).includes(defaultProvider) ? defaultProvider : Auth.TYPE.PHONE;
    this.setDefaultProvider(provider);

    this.getAuthProviders();

    this.show();
  }

  showKyc() {
    this.identity = DCStatic.phoneNumber;
    if (LocalStorage.isMiniApp()) {
      MINI_APP.login(this.identity);
      return;
    }

    this.setType(TYPE.KYC);
    this.setDefaultProvider(Auth.TYPE.PHONE);
    this.authConfirm.updateAttributes({
      provider: this.provider,
      identity: this.identity
    })
    this.show();

    this.onSubmit(DCStatic.phoneNumber);
  }

  showAuthMoreInfo() {
    if (LocalStorage.isMiniApp()) {
      return;
    }

    this.userInfo.showUserInfo();
    this.setStep(STEP_AUTH.USERINFO);

    this.showStatic();
  }

  getAuthProviders() {
    apiGetAuthProvider({
      "v": Date.now(),
      "cache": "no-cache",
    },
      (data) => {
        let defaultProvider = this.provider;
        let listProviders = this.addQueryDebug([...Auth.LIST_AUTH_DEFAULT, ...(data?.data ?? [])]);

        if (!listProviders.find(item => item.code === defaultProvider)) {
          defaultProvider = listProviders[0]?.code;
        }
        this.setDefaultProvider(defaultProvider);
        this.otherAuth.setListProvider(listProviders);
        LocalStorage.setAuthProviders(data?.data);
      },
      (error) => {
        let listProviders = this.addQueryDebug(Auth.LIST_AUTH_DEFAULT);
        this.setDefaultProvider(listProviders[0]?.code);
        this.otherAuth.setListProvider(listProviders);
        LocalStorage.setAuthProviders([]);
      }
    )
  }

  addQueryDebug(listProviders = []) {
    if (!listProviders.length || !Array.isArray(listProviders)) return listProviders;

    let result = listProviders;
    let featureList = {
      [LIST_QUERYSTRING.AUTH.PHONE]: Auth.TYPE.PHONE,
      [LIST_QUERYSTRING.AUTH.EMAIL]: Auth.TYPE.EMAIL,
      [LIST_QUERYSTRING.AUTH.GOOGLE]: Auth.TYPE.GOOGLE,
      [LIST_QUERYSTRING.AUTH.APPLE]: Auth.TYPE.APPLE,
      [LIST_QUERYSTRING.AUTH.FACEBOOK]: Auth.TYPE.FACEBOOK,
    };

    handleFeatureCallback({
      listKey: Object.keys(featureList),
      onActive: (key) => {
        if (!result.find(item => item.code === featureList[key])) {
          result.push({
            code: featureList[key],
          });
        }
      },
      onDeactive: (key) => {
        result = result.filter(item => item.code !== featureList[key]);
      }
    })

    return result;
  }

  setDefaultProvider(defaultProvider) {
    if (this.type === TYPE.LOGIN) {
      this.setStep(STEP_AUTH.START_LOGIN);
      this.otherAuth.onChange(defaultProvider, true);
    }

    if (this.type === TYPE.KYC) {
      this.setStep(STEP_AUTH.OTP);
    }

    this.changeProvider(defaultProvider, true);
  }

  hide() {
    this.element.modal("hide");
  }

  setStep(step) {
    $(".modal-content", this.element).attr("step", step);
    this.step = step;

    switch (step) {
      case STEP_AUTH.OTP:
        $(".description b", this.element).text(this.identity);
        break;

      default:
        break;
    }
  }

  setType(type) {
    this.type = type;
    $(".modal-content", this.element).attr("type", type);
  }

  setTitle() {
    setTranslateElements([
      { element: $(".group-title[step='login'] h2", this.element), i18nKey: this.isMerchant ? "login_merchantTitle" : "login_welcome", isHtml: true },
      { element: $(".group-title[step='login'] .description", this.element), i18nKey: this.isMerchant ? "login_merchantDescription" : "login_welcomeDescription", isHtml: true },
    ])
  }
  setOnCancel(onCancel) {
    this.onCancel = onCancel;
  }

  setCallBack(onCallBack) {
    this.onCallBack = onCallBack;
  }

  setHideCallBack(onHideCallBack) {
    this.onHideCallBack = onHideCallBack;
  }

  setIsMerchant(value) {
    this.isMerchant = value;
  }

  resetAuth() {
    this.setStep(STEP_AUTH.START_LOGIN);
    this.provider = Auth.TYPE.PHONE;
    this.identity = "";
    this.accessToken = "";
    this.onCancel = undefined;
    this.onCallBack = undefined;
    this.onHideCallBack = undefined;
    clearTimeout(this.translateTimeout);
    this.translateTimeout = undefined;
    this.isMerchant = false;
  }

  get authEmail() {
    if (!this._authEmail) {
      this._authEmail = new AuthEmail({
        parent: $(".identity-form", this.element),
        onSubmit: (identity) => this.onSubmit(identity),
      })
    }
    return this._authEmail;
  }

  set authEmail(value) {
    this._authEmail = value;
  }

  get authPhone() {
    if (!this._authPhone) {
      this._authPhone = new AuthPhoneNumber({
        parent: $(".identity-form", this.element),
        onSubmit: (identity) => this.onSubmit(identity),
      })
    }
    return this._authPhone;
  }

  set authPhone(value) {
    this._authPhone = value;
  }

  get authGoogle() {
    if (!this._authGoogle) {
      this._authGoogle = new AuthGoogle({
        parent: $(".identity-form", this.element),
        onError: (error) => this.onError(error),
        onSubmit: (credential) => this.onSubmit(undefined, credential),
      })
    }
    return this._authGoogle;
  }

  set authGoogle(value) {
    this._authGoogle = value;
  }

  get authFaceBook() {
    if (!this._authFaceBook) {
      this._authFaceBook = new AuthFacebook({
        parent: $(".identity-form", this.element),
        onError: (error) => this.onError(error),
        onSubmit: (credential) => this.onSubmit(undefined, credential),
      })
    }
    return this._authFaceBook;
  }

  set authFaceBook(value) {
    this._authFaceBook = value;
  }

  get authApple() {
    if (!this._authApple) {
      this._authApple = new AuthApple({
        parent: $(".identity-form", this.element),
        onError: (error) => this.onError(error),
        onSubmit: (credential) => this.onSubmit(undefined, credential),
      })
    }
    return this._authApple;
  }

  set authApple(value) {
    this._authApple = value;
  }

  get authConfirm() {
    if (!this._authConfirm) {
      this._authConfirm = new ConfirmOTP({
        parent: $(".otp-form", this.element),
        onSubmit: (user) => this.onConfirmCodeSuccess(user),
        cancelButton: this.type === TYPE.KYC ? "checkout_chooseOtherPaymentOption" : "",
        onCancel: this.onCancel
      })
    }
    return this._authConfirm;
  }

  set authConfirm(value) {
    this._authConfirm = value;
  }

  get userInfo() {
    if (!this._userInfo) {
      this._userInfo = new UserInfo({
        parent: $(".user-info-form", this.element),
        name: DCStatic.displayName || LocalStorage.getUserName(),
        email: DCStatic.email || LocalStorage.getUserEmail(),
        onSubmit: (user) => this.onSaveUserInfo(user),
      })
    }
    return this._userInfo;
  }

  set userInfo(value) {
    this._userInfo = value;
  }
}